// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpressDeliveryFilter_container__17O5V","labelContainer":"ExpressDeliveryFilter_labelContainer__xbjJY","label":"ExpressDeliveryFilter_label__QPfHs"};